import React, { useEffect, useState } from "react";
const API_URL = process.env.REACT_APP_API_URL;
const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;

export default function JoinClass() {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/teacher/available-classes`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch classes");
        return res.json();
      })
      .then((data) => {
        setClasses(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setError("Could not load classes");
        setLoading(false);
      });
  }, []);

  const handleJoin = async (cls) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || user.role !== "student") {
      return alert("Please log in as a student to join classes.");
    }

    try {
      const res = await fetch(`${API_URL}/api/teacher/enroll`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ classId: cls._id, studentId: user._id }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to enroll");

      window.open(cls.zoomLink, "_blank");
    } catch (err) {
      alert(err.message);
    }
  };

  const handlePayment = async (cls) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || user.role !== "student") {
      return alert("Please log in as a student to pay.");
    }

    const tx_ref = `class-${cls._id}-${Date.now()}`;
    const amount = cls.price || 10;

    try {
      const res = await fetch(`${API_URL}/api/payment/create`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount,
          email: user.email,
          first_name: user.name?.split(" ")[0] || "Student",
          last_name: user.name?.split(" ")[1] || "",
          tx_ref,
          callback_url: `${FRONTEND_URL}/paymentSuccess`,
        }),
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || "Failed to initialize payment");
      }

      const { checkoutUrl } = await res.json();

      // Redirect to Chapa payment page
      window.location.href = checkoutUrl;
    } catch (error) {
      alert("Payment initialization failed: " + error.message);
    }
  };

  if (loading)
    return <div className="p-8 text-center text-lg">⏳ Loading classes...</div>;

  if (error)
    return (
      <div className="p-8 text-center text-red-600 font-semibold">⚠️ {error}</div>
    );

  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Available Live Classes</h1>

      {classes.length === 0 ? (
        <p className="text-gray-500">No live classes available at the moment.</p>
      ) : (
        <div className="grid gap-4">
          {classes.map((cls) => (
            <div
              key={cls._id}
              className="border p-4 rounded shadow hover:shadow-md transition"
            >
              <h2 className="text-xl font-semibold mb-1">
                {cls.title ?? "Untitled Class"}
              </h2>
              <p className="mb-2">{cls.description ?? "No description provided."}</p>
              <p className="text-sm text-gray-500 mb-1">
                📅{" "}
                {cls.scheduledAt
                  ? new Date(cls.scheduledAt).toLocaleString()
                  : "Unscheduled"}
              </p>
              <p className="text-sm text-gray-600 mb-2">
                👨‍🏫 {cls.teacher?.name ?? "Unknown Teacher"}
              </p>
              <p className="text-sm text-blue-600 font-semibold mb-3">
                💵 Price: {cls.price ?? "Free"}
              </p>
              <div className="flex gap-2">
                <button
                  className={`px-4 py-2 rounded text-white ${
                    cls.zoomLink
                      ? "bg-green-600 hover:bg-green-700"
                      : "bg-gray-400 cursor-not-allowed"
                  }`}
                  onClick={() => handleJoin(cls)}
                  disabled={!cls.zoomLink}
                >
                  {cls.zoomLink ? "Join Class" : "No Zoom Link"}
                </button>
                <button
                  onClick={() => handlePayment(cls)}
                  className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white"
                >
                  Pay Now
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
